import { defineComponent as _defineComponent } from 'vue';
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridBoolean',
    props: {
        value: { type: Boolean }
    },
    setup(__props) {
        return { __sfc: true, faCheck, faTimes };
    }
});
